import React from 'react';

/* One tab row. variant "main" → the crimson/orange `newtab_collect` tabs;
   variant "sub" → the dark `fancy-subtabs` bar. Clicking switches the active
   index (React-controlled). The main tab carries an extra empty <span> (icon
   slot) exactly like the reference DOM. */
export default function FancyTabs({ variant, tabs, active, onChange }) {
  const isSub = variant === 'sub';
  const ulCls = isSub ? 'nav nav-tabs fancy-subtabs' : 'nav nav-tabs';
  return (
    <ul role="tablist" className={ulCls} aria-label="Tabs">
      {tabs.map((label, i) => {
        const on = i === active;
        return (
          <li key={label} className={on ? 'active nav-item' : 'nav-item'}>
            <a
              href="javascript:void(0);"
              role="tab"
              aria-selected={on}
              className={on ? 'nav-link active' : 'nav-link'}
              onClick={(e) => { e.preventDefault(); onChange(i); }}
            >
              {!isSub && <span />}
              <span>{label}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
